<template>

  <div class="ue-expenses-edit">
    <el-card>
      <div class="header">
        <h2>Контингент обучающихся (Год: {{ dto.trancheYear }})</h2>
        <div>
          <el-button @click="goBack">Назад</el-button>
          <el-button type="primary" @click="submitForm()" :loading="isLoading" v-if="dto.status !== 'APPROVED' && hasEditPermission()">Сохранить</el-button>
        </div>
      </div>

      <form>

        <div class="table-container" @paste="handlePaste" @keydown="handleKeydown">

          <table class="grid-table">
            <thead>
            <tr>
              <th class="meta-cell header-success" rowspan="3">Уровни образования</th>
              <th class="meta-cell header-success" rowspan="3">Код области образования</th>
              <th class="title-cell header-success" rowspan="3">код и наименование специальности
                НАПРАВЛЕНИЕ ПОДГОТОВКИ</th>
              <th class="meta-cell header-success" rowspan="3">ВСЕГО</th>
              <th class="meta-cell header-success" colspan="9">в том числе</th>
              <template v-for="c in courses">
                <th class="meta-cell header-success color-red" rowspan="3">{{c}} курс</th>
                <th class="meta-cell header-success" colspan="9">в том числе</th>
              </template>
            </tr>
            <tr>
              <th class="meta-cell header-success" rowspan="2">ГОЗ</th>
              <th class="meta-cell header-success" colspan="2">из них</th>

              <th class="meta-cell header-success" rowspan="2">Грант от предприятий и организаций</th>
              <th class="meta-cell header-success" colspan="2">из них</th>

              <th class="meta-cell header-success" rowspan="2">Коммерческое </th>
              <th class="meta-cell header-success" colspan="2">из них</th>

              <template v-for="c in courses">
                <th class="meta-cell header-success" rowspan="2">ГОЗ</th>
                <th class="meta-cell header-success" colspan="2">из них</th>

                <th class="meta-cell header-success" rowspan="2">Грант от предприятий и организаций</th>
                <th class="meta-cell header-success" colspan="2">из них</th>

                <th class="meta-cell header-success" rowspan="2">Коммерческое </th>
                <th class="meta-cell header-success" colspan="2">из них</th>
              </template>
            </tr>
            <tr>
                <th class="meta-cell header-success" >местные программы</th>
                <th class="meta-cell header-success" >программы с иностр. участием</th>

                <th class="meta-cell header-success" >местные программы</th>
                <th class="meta-cell header-success" >программы с иностр. участием</th>

                <th class="meta-cell header-success" >местные программы</th>
                <th class="meta-cell header-success" >программы с иностр. участием</th>
              <template v-for="c in courses">
                <th class="meta-cell header-success" >местные программы</th>
                <th class="meta-cell header-success" >программы с иностр. участием</th>

                <th class="meta-cell header-success" >местные программы</th>
                <th class="meta-cell header-success" >программы с иностр. участием</th>

                <th class="meta-cell header-success" >местные программы</th>
                <th class="meta-cell header-success" >программы с иностр. участием</th>
              </template>
            </tr>
            </thead>
            <tbody>
            <tr class="total-row calculated-row readonly-text">
              <td colspan="3" class="sticky col-1">ВСЕГО КОНТИНГЕНТ</td>
              <td>{{ formatNumber(dto.total) }}</td>
              <td>{{ formatNumber(dto.goz) }}</td>
              <td>{{ formatNumber(dto.gozLocal) }}</td>
              <td>{{ formatNumber(dto.gozForeign) }}</td>
              <td>{{ formatNumber(dto.org) }}</td>
              <td>{{ formatNumber(dto.orgLocal) }}</td>
              <td>{{ formatNumber(dto.orgForeign) }}</td>
              <td>{{ formatNumber(dto.comm) }}</td>
              <td>{{ formatNumber(dto.commLocal) }}</td>
              <td>{{ formatNumber(dto.commForeign) }}</td>
              <template v-for="c in courses">
                <template v-if="dto.courseTotal">
                  <td>{{ formatNumber(dto.courseTotal[c].total) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].goz) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].gozLocal) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].gozForeign) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].org) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].orgLocal) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].orgForeign) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].comm) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].commLocal) }}</td>
                  <td>{{ formatNumber(dto.courseTotal[c].commForeign) }}</td>
                </template>


              </template>
            </tr>
            <template v-for="(degree, dIndex) in dto.degrees" :key="degree.uuid || dIndex">
              <tr class="total-row calculated-row readonly-text">
                <td colspan="3" class="sticky col-1">{{degree.title}}</td>
                <td>{{ formatNumber(degree.total) }}</td>
                <td>{{ formatNumber(degree.goz) }}</td>
                <td>{{ formatNumber(degree.gozLocal) }}</td>
                <td>{{ formatNumber(degree.gozForeign) }}</td>
                <td>{{ formatNumber(degree.org) }}</td>
                <td>{{ formatNumber(degree.orgLocal) }}</td>
                <td>{{ formatNumber(degree.orgForeign) }}</td>
                <td>{{ formatNumber(degree.comm) }}</td>
                <td>{{ formatNumber(degree.commLocal) }}</td>
                <td>{{ formatNumber(degree.commForeign) }}</td>
                <template v-for="course in degree.items">
                    <td>{{ formatNumber(course.total) }}</td>
                    <td>{{ formatNumber(course.goz) }}</td>
                    <td>{{ formatNumber(course.gozLocal) }}</td>
                    <td>{{ formatNumber(course.gozForeign) }}</td>
                    <td>{{ formatNumber(course.org) }}</td>
                    <td>{{ formatNumber(course.orgLocal) }}</td>
                    <td>{{ formatNumber(course.orgForeign) }}</td>
                    <td>{{ formatNumber(course.comm) }}</td>
                    <td>{{ formatNumber(course.commLocal) }}</td>
                    <td>{{ formatNumber(course.commForeign) }}</td>
                </template>
              </tr>
            <template v-for="(cat, rowIndex) in degree.categories" :key="cat.uuid || rowIndex">
              <tr>
                <td class="sticky col-1"></td>
                <td class="sticky col-2">{{ cat.eduAreaCode }}
                  <el-button  type="text" class="btn-icon color-red" @click="removeItem(rowIndex, cat)">
                    &times;
                  </el-button>
                </td>
                <td class="sticky col-3">{{ catMap.catNames[cat.profDirCode] }}</td>

                <td class="calculated-cell">{{ formatNumber(cat.total) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.goz) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.gozLocal) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.gozForeign) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.org) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.orgLocal) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.orgForeign) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.comm) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.commLocal) }}</td>
                <td class="calculated-cell">{{ formatNumber(cat.commForeign) }}</td>
<!--                <template v-for="c in courses">-->
                  <template v-for="course in cat.items">
                    <td :class="'calculated-cell c-' + course.course">{{ formatNumber(course.total) }}</td>
                    <td class="calculated-cell">{{ formatNumber(course.goz) }}</td>
                    <td class="expense-sum-edit">
                      <input :value="getCellValue(course, 'gozLocal')"
                             @focus="onFocus($event, course, 'gozLocal')"
                             @blur="onBlur($event, course, 'gozLocal')"
                             @input="onInput($event, course, 'gozLocal', 'goz')"
                             :data-row="rowIndex"
                             :data-col="0"
                             class="cell-input"
                             type="text"
                      />
                    </td>
                    <td class="expense-sum-edit">
                      <input :value="getCellValue(course, 'gozForeign')"
                             @focus="onFocus($event, course, 'gozForeign')"
                             @blur="onBlur($event, course, 'gozForeign')"
                             @input="onInput($event, course, 'gozForeign', 'goz')"
                             :data-row="rowIndex"
                             :data-col="0"
                             class="cell-input"
                             type="text"
                      />
                    </td>
                    <td class="calculated-cell">{{ formatNumber(course.org) }}</td>
                    <td class="expense-sum-edit">
                      <input :value="getCellValue(course, 'orgLocal')"
                             @focus="onFocus($event, course, 'orgLocal')"
                             @blur="onBlur($event, course, 'orgLocal')"
                             @input="onInput($event, course, 'orgLocal', 'org')"
                             :data-row="rowIndex"
                             :data-col="0"
                             class="cell-input"
                             type="text"
                      />
                    </td>
                    <td class="expense-sum-edit">
                      <input :value="getCellValue(course, 'orgForeign')"
                             @focus="onFocus($event, course, 'orgForeign')"
                             @blur="onBlur($event, course, 'orgForeign')"
                             @input="onInput($event, course, 'orgForeign', 'org')"
                             :data-row="rowIndex"
                             :data-col="0"
                             class="cell-input"
                             type="text"
                      />
                    </td>
                    <td class="calculated-cell">{{ formatNumber(course.comm) }}</td>
                    <td class="expense-sum-edit">
                      <input :value="getCellValue(course, 'commLocal')"
                             @focus="onFocus($event, course, 'commLocal')"
                             @blur="onBlur($event, course, 'commLocal')"
                             @input="onInput($event, course, 'commLocal', 'comm')"
                             :data-row="rowIndex"
                             :data-col="0"
                             class="cell-input"
                             type="text"
                      />
                    </td>
                    <td class="expense-sum-edit">
                      <input :value="getCellValue(course, 'commForeign')"
                             @focus="onFocus($event, course, 'commForeign')"
                             @blur="onBlur($event, course, 'commForeign')"
                             @input="onInput($event, course, 'commForeign', 'comm')"
                             :data-row="rowIndex"
                             :data-col="0"
                             class="cell-input"
                             type="text"
                      />
                    </td>
                  </template>

<!--                </template>-->



              </tr>


            </template>
            </template>
            </tbody>
          </table>
        </div>
      </form>

      <div class="d-flex align-items-center" v-if="dto.status !== 'APPROVED' && hasEditPermission()">
        <div class="mb-3">
          <el-select v-model="selectedCategory" filterable placeholder="Выберите" size="small" style="width: 300px" >
            <el-option v-for="item in availableCategories()" :key="item.code" :label="item.fullName" :value="item.code"></el-option>
          </el-select>
        </div>

        <div class="mb-3" >
          <el-button type="success" size="small" @click="addItem" :disabled="!selectedCategory">
            <font-awesome-icon :icon="['fas', 'plus']"/> Добавить категорию
          </el-button>
        </div>
      </div>
    </el-card>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {showErrorNotify, showSuccessNotify} from "@/utils/notificationUtils";
import delegationService from "@/services/delegationService";
import ueExpensesCommonCrudService from "@/services/expenses/ueExpensesCommonCrudService";
import {handleGridKeydown} from "@/utils/gridKeyboardNav";
import professionService from "@/services/professionService";
import professionDirectionService from "@/services/professionDirectionService";

const ALL_PASTE_FIELDS = ['total', 'goz', 'gozLocal', 'gozForeign', 'org', 'orgLocal', 'orgForeign', 'comm', 'commLocal', 'commForeign'];
export default {
  components: {
    VueLoading
  },
  computed: {
    uuid() {
      return this.$route.params.uuid;
    },
  },
  data() {
    return {
      isLoading: false,
      expenseType: 'contingent',
      dto: {
        uuid: null,
        trancheYear: null,
        universityId: null,
        status: null,
        degrees: []
      },
      catMap: { catNames: {}},
      selectedCategory: null,
      focusedCell: null,
      courses: [1, 2, 3, 4, 5],
      degreeCodes: {
        'B': [1, 'Бакалавриат'],
        'M': [2, 'Магистратура'],
        'D': [3, 'Докторантура (PhD)'],
      }
    };
  },
  methods: {
    init() {
      this.findById(this.uuid);
    },

    async findById(uuid) {
      this.isLoading = true;
      this.initProfessions();
      this.dto = await ueExpensesCommonCrudService.findById(this.expenseType, uuid);
      this.recalculate();
      this.isLoading = false;
    },
    initProfessions() {
      professionDirectionService.getAllDirectionList()
          .then(response => {
            this.catMap.categories = response.sort((a, b) => a.code.localeCompare(b.code));
            response.forEach(cat => {
              cat.fullName = `${cat.code} ${cat.nameRu}`;
              this.catMap.catNames[cat.code] = cat.fullName;
            });
          });
    },
    async submitForm() {
      try {
        if (!this.hasEditPermission()) return;
        this.isLoading = true;
        this.dto = await ueExpensesCommonCrudService.save(this.expenseType, this.dto);
        this.recalculate();
        showSuccessNotify("Успешно сохранено!");
      } catch (exc) {
        console.error(exc);
        showErrorNotify("Возникла ошибка при сохранении");
      } finally {
        this.isLoading = false;
      }
    },
    availableCategories() {
      const usedCodes = new Set(
          this.dto.degrees.flatMap(d => d.categories || [])
              .map(cat => cat.profDirCode)
      );

      return this.catMap?.categories?.filter(
          c => !usedCodes.has(c.code)
      );
    },
    addItem() {
      if (!this.selectedCategory) return;

      const cat = this.catMap?.categories?.find(c => c.code === this.selectedCategory);
      if (!cat) return;

      if (cat) {
        const dto = {profDirCode: cat.code, items: [], eduAreaCode: cat.eduAreaCode};

        for (const c of this.courses) {
          dto.items.push({course: c})
        }

        for (const code of Object.keys(this.degreeCodes)) {
          if (cat.code.includes(code)) {
            let degree = this.dto.degrees.filter(d => d.code === code);
            if (degree.length === 0) {
              degree = {code: code, title: this.degreeCodes[code][1], categories: [], items:[], sort: this.degreeCodes[code][0]};
              for(let c of this.courses) {
                degree.items.push({course: c});
              }
              this.dto.degrees.push(degree);
            } else {
              degree = degree[0];
            }
            degree.categories.push(dto);
          }
        }
      }
      this.selectedCategory = null;
      this.recalculate();
    },

    async removeItem(index, item) {
      if (item.uuid) {
        try {
          await ueExpensesCommonCrudService.deleteCategory(this.expenseType, this.dto.uuid, item.uuid);
          this.findById(this.uuid);
          showSuccessNotify('Удалено');
        } catch (exc) {
          showErrorNotify('Ошибка при удалении');
        }
      }
    },

    parseNumber(str) {
      if (str === null || str === undefined || str === '') return 0;
      const cleaned = String(str).replace(/\s/g, '').replace(',', '');
      const num = parseFloat(cleaned);
      return isNaN(num) ? 0 : num;
    },

    formatNumber(val) {
      const num = typeof val === 'number' ? val : this.parseNumber(val);
      if (num === 0) return '';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    getCellValue(item, field) {
      if (this.focusedCell && this.focusedCell.item === item && this.focusedCell.field === field) {
        return this.editingValue;
      }
      return item && item[field]? this.getDisplayValue(item[field]): '';
    },
    getDisplayValue(val) {
      const num = this.parseNumber(val);
      if (num === 0) return '';
      return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },

    onFocus(event, item, field) {
      this.focusedCell = { item, field };
      const num = this.parseNumber(item[field]);
      this.editingValue = num === 0 ? '' : String(num).replace('.', ',');
      event.target.value = this.editingValue;
    },

    onBlur(event, item, field) {
      this.focusedCell = null;
      const num = this.parseNumber(event.target.value);
      item[field] = num === 0 ? null : Math.round(num * 100) / 100;
      event.target.value = this.getDisplayValue(item[field]);
      this.recalculate();
    },

    onInput(event, item, field, totalField) {
      this.editingValue = event.target.value;
      const num = this.parseNumber(event.target.value);
      item[field] = num === 0 ? null : num;
      if (totalField) {
        item[totalField] = (item[totalField + 'Local'] || 0) + (item[totalField + 'Foreign'] || 0);
      }
      this.recalculate();
    },

    recalculate() {
      if (!this.dto.degrees || this.dto.degrees.length === 0) {
        return;
      }

      for (var i = ALL_PASTE_FIELDS.length - 1; i >= 0; i--) {
        const f = ALL_PASTE_FIELDS[i];
        this.dto[f] = 0;
        for (let c of this.courses) {
          if (this.dto.courseTotal[c]) {
            this.dto.courseTotal[c][f] = 0;
          }
        }

        for (const degree of this.dto.degrees) {
          degree[f] = 0;
          if (degree.items?.length) {
            for (const item of degree.items) {
              if (f === 'total') {
                item.total = (item.goz || 0) + (item.org || 0) + (item.comm || 0);
              }
              if (item[f]) {
                degree[f] += this.parseNumber(item[f]);
              }
            }
          }

          for (const cat of degree.categories) {
            cat[f] = 0;
            if (cat.items?.length) {
              for (const item of cat.items) {
                if (f === 'total') {
                  item.total = (item.goz || 0) + (item.org || 0) + (item.comm || 0);
                }
                if (item[f]) {
                  cat[f] += this.parseNumber(item[f]);
                }
              }
            }

            this.dto[f] += this.parseNumber(cat[f]);

            for (let c of this.courses) {
              if (!this.dto.courseTotal) {
                this.dto.courseTotal = {};
              }
              if (!this.dto.courseTotal[c]) {
                this.dto.courseTotal[c] = {
                  total: 0,
                  goz: 0,
                  gozLocal: 0,
                  gozForeign: 0,
                  org: 0,
                  orgLocal: 0,
                  orgForeign: 0,
                  comm: 0,
                  commLocal: 0,
                  commForeign: 0
                };
              }
              const courseItem = cat.items.find(i => i.course === c);
              if (courseItem && courseItem[f]) {
                this.dto.courseTotal[c][f] += this.parseNumber(courseItem[f]);
              }
            }
            cat.items.sort((a, b) => a.course - b.course);
          }

          degree.items.sort((a, b) => a.course - b.course);
        }
        this.dto.degrees.sort((a, b) => a.sort - b.sort);
      }
      console.log('Recalculated totals:', this.dto);

    },

    handleKeydown(event) {
      handleGridKeydown(event, this.$el);
    },

    handlePaste(event) {
      const target = event.target;
      if (!target || target.tagName !== 'INPUT') return;

      const startRow = parseInt(target.dataset.row);
      const startCol = parseInt(target.dataset.col);
      if (isNaN(startRow) || isNaN(startCol)) return;

      const clipboardData = event.clipboardData || window.clipboardData;
      if (!clipboardData) return;

      const text = clipboardData.getData('text/plain');
      if (!text) return;

      const rows = text.split(/\r?\n/).filter(r => r.trim() !== '');
      if (rows.length <= 1 && !rows[0].includes('\t')) return;

      event.preventDefault();

      for (let r = 0; r < rows.length; r++) {
        const cols = rows[r].split('\t');
        const itemIdx = startRow + r;
        if (itemIdx >= this.dto.categories.length) break;

        for (let c = 0; c < cols.length; c++) {
          const colIdx = startCol + c;
          if (colIdx >= ALL_PASTE_FIELDS.length) break;

          const num = this.parseNumber(cols[c]);
          this.dto.categories[itemIdx][ALL_PASTE_FIELDS[colIdx]] = num === 0 ? null : num;
        }
      }

      this.recalculate();
      this.$forceUpdate();
    },

    goBack() {
      this.$router.go(-1);
    },
    hasEditPermission() {
      return this.isUniversityManager() && (this.dto.status === 'CREATED' || !this.dto.status);
    },
    isUniversityManager() {
      return delegationService.isUniversityManager();
    },
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped>
.color-red, .color-red:hover {  color: red !important; margin-top: -5px;}
.header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; }
.table-container { width: 100%; overflow-x: auto; }
.grid-table { width: 100%; border-collapse: collapse; min-width: 3000px; }
.grid-table th, .grid-table td { border: 1px solid #EBEEF5; padding: 8px; font-size: 12px; }
.grid-table th { background-color: #f5f7fa; text-align: center; font-weight: bold; position: sticky; top: 0; z-index: 10; }
.header-success { background-color: #d4edda !important; }
.title-cell { width: 180px; min-width: 180px; }
.meta-cell { width: 60px; min-width: 60px; }
.month-cell { width: 85px; min-width: 85px; }
.total-cell { width: 100px; min-width: 100px; }
.action-col { width: 50px; min-width: 50px; text-align: center; }
.name-cell { min-width: 180px; }
.calculated-cell { text-align: right; background-color: #f9f9f9; }
.calculated-row { background-color: #f0f9eb; font-weight: bold; }
.readonly-text { text-align: right; padding-right: 10px !important; }
.total-row td { font-weight: bold; text-align: right; }
.total-row td:first-child { text-align: left; }

.expense-sum-edit { padding: 2px !important; }

.cell-input {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  text-align: right;
  font-size: 12px;
  padding: 4px 6px;
  box-sizing: border-box;
}

.cell-input.text-left {
  text-align: left;
}

.cell-input:focus {
  background-color: #fff;
  border: 1px solid #409eff;
  border-radius: 2px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
.expense-sum-edit, .calculated-cell {
 min-width: 100px;
}

/* sticky*/
.sticky {
  position: sticky;
  background: white;
  z-index: 2;
}
.sticky-th {
  position: sticky;
  z-index: 2;
}
thead th {
  position: sticky;
  top: 0;
  z-index: 3;
}
.col-1 {
  left: 0;
  min-width: 100px;
}

/* second column */
.col-2 {
  left: 100px; /* width первой колонки */
  min-width: 200px;
}

.col-3 {
  left: 150px; /* width первой колонки */
  min-width: 200px;
}
</style>
